module.exports = __webpack_public_path__ + "img/diageo.268c05c9.png";